import { SxProps, Theme } from '@mui/material';
import { brandAlpha, brandColors } from '../../theme/mixins';

/**
 * Never wider than the phone it may open on, and never taller than leaves the page behind it
 * visible: the list scrolls inside the panel rather than the panel off the screen.
 */
export const bellPaperStyles: SxProps<Theme> = {
    borderRadius: 3,
    width: { xs: 'calc(100vw - 32px)', sm: 400 },
    maxWidth: 400,
    maxHeight: 'min(70vh, 560px)',
    overflowY: 'auto',
    p: 2,
};

export const bellHeaderStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    mb: 1,
};

export const bellTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
    fontSize: '1.125rem',
};

export const bellEmptyStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.875rem',
    py: 2,
};

export const bellListStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
};

/** Unread is said three ways -- the dot, the weight and the tint -- so none has to carry it alone. */
export const getBellRowStyles = (read: boolean): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.25,
    px: 1,
    py: 1.25,
    borderRadius: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
    backgroundColor: read ? 'transparent' : brandAlpha('primary', 0.04),
});

export const getBellDotStyles = (read: boolean): SxProps<Theme> => ({
    flexShrink: 0,
    width: 8,
    height: 8,
    mt: 0.875,
    borderRadius: '50%',
    backgroundColor: read ? 'transparent' : brandColors.secondary,
});

export const bellRowBodyStyles: SxProps<Theme> = {
    minWidth: 0,
    flexGrow: 1,
};

export const getBellRowTitleStyles = (read: boolean): SxProps<Theme> => ({
    fontWeight: read ? 500 : 700,
});

export const bellRowWhenStyles: SxProps<Theme> = {
    fontWeight: 600,
    fontSize: '0.875rem',
};

export const bellRowDetailStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.875rem',
};

export const bellRowStampStyles: SxProps<Theme> = {
    color: 'text.secondary',
    fontSize: '0.75rem',
    mt: 0.25,
};

/** The way to the switch on Profile: under everything, and set apart from the news above it. */
export const bellFooterStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    mt: 1,
    pt: 1,
    borderTop: '1px solid',
    borderColor: 'divider',
};

export const bellShowMoreStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    pt: 1,
};
